/**
 * Device detection utility
 * Detects if the user is on a mobile device, tablet, or desktop
 */

export const isMobileDevice = () => {
  // Check for touch capability and screen size
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Mobile patterns
  const mobilePatterns = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
    /Opera Mini/i,
    /IEMobile/i,
    /Mobile/i,
    /mobile/i,
  ];

  // Check user agent
  const isMobileUA = mobilePatterns.some(pattern => pattern.test(userAgent));
  
  // Also check screen width (mobile/tablet typically < 1024px)
  const isMobileWidth = window.innerWidth < 1024;
  
  // Check for touch capability
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return isMobileUA || (isMobileWidth && hasTouch);
};

export const isTabletDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Tablet patterns
  const tabletPatterns = [
    /iPad/i,
    /Android(?!.*Mobile)/i,
    /Tablet/i,
  ];
  
  const isTabletUA = tabletPatterns.some(pattern => pattern.test(userAgent));
  const isTabletWidth = window.innerWidth >= 600 && window.innerWidth < 1024;
  
  return isTabletUA || isTabletWidth;
};

export const getDeviceType = () => {
  if (isMobileDevice()) {
    return isTabletDevice() ? 'tablet' : 'mobile';
  }
  return 'desktop';
};

export const shouldRedirectToMobile = () => {
  // Returns true if user should be redirected to mobile interface
  return isMobileDevice();
};
